var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTensoquines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#Degradado_sin_nombre_6);}.cls-2{fill:#b8b8b7;}.cls-3{fill:#cfcfcf;}.cls-4{fill:none;}.cls-5{fill:#009ee2;}.cls-6{fill:#9c9b9b;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_6",
    x1: 398.38,
    y1: 718.06,
    x2: 465.66,
    y2: 718.06,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c9b9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8b8b7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 1080,
    height: 1080
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 540,
    cy: 540,
    r: 457.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M818.05,602.38l-369.01,207.21c-8.13,4.56-18.09,4.36-26.02-.52l-8.48-5.22,7.69-155.69,28.63-30.24,381.19-220.67v181.22c0,9.92-5.35,19.06-14,23.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M417.33,805.57l-167.94-103.27c-3.68-2.17-5.95-6.13-5.95-10.41v-167.35l175,109.7,11.9,3.25-13.01,168.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M823.44,416.29l-386.47,216.57c-5.13,2.95-16.91,3.58-22.14,.79l-162.57-99.4c-12.13-6.47-12.12-18.73,0-25.19l393.02-222.22c4.84-2.58,10.63-2.69,15.57-.29l161.51,99.4c12.41,6.02,13.02,23.46,1.07,30.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M398.38,793.91l25.63,15.78c13.23,8.33,22.93,1.1,25.52-.35l16.12-9.04-9.91-177.81-13.56,7.53c-10.8,6-23.99,5.7-34.51-.77l-4.28-2.64-5.02,167.29Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTensoquines);
export default __webpack_public_path__ + "static/media/tensoquines.2539bc36341206c5ca4f8ab38e302759.svg";
export { ForwardRef as ReactComponent };